import React, { useState, useEffect } from 'react';

export default function OfflineBanner() {
  const [online, setOnline]           = useState(navigator.onLine);
  const [showRestored, setShowRestored] = useState(false);

  useEffect(() => {
    let restoreTimer;

    const handleOnline = () => {
      setOnline(true);
      setShowRestored(true);
      restoreTimer = setTimeout(() => setShowRestored(false), 3000);
    };
    const handleOffline = () => {
      setOnline(false);
      setShowRestored(false);
      clearTimeout(restoreTimer);
    };

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(restoreTimer);
    };
  }, []);

  if (online && !showRestored) return null;

  const isRestored = online && showRestored;

  return (
    <div style={{
      position:     'fixed',
      top:          0,
      left:         0,
      right:        0,
      zIndex:       1000,
      textAlign:    'center',
      padding:      '.4rem 1rem',
      fontSize:     '.78rem',
      fontFamily:   'var(--font-body)',
      background:   isRestored ? 'rgba(45,106,79,.92)' : 'rgba(20,14,6,.93)',
      color:        isRestored ? '#86efac' : 'rgba(253,246,227,.7)',
      borderBottom: `1px solid ${isRestored ? 'rgba(64,145,108,.5)' : 'rgba(255,255,255,.07)'}`,
      backdropFilter: 'blur(10px)',
      transition:   'background .3s, color .3s',
    }}>
      {isRestored
        ? '✅ Connexion rétablie'
        : '📡 Mode hors-ligne — questions en cache'}
    </div>
  );
}
